import React from 'react'
import BookDemoModal from './BookDemoModal'
import RateAppModal from './RateAppModal'

export default function Onboarding() {
  return (
    <>
      <BookDemoModal />
      <RateAppModal />
    </>
  )
}
